<template>
    <simple-layout
        class="help-page"
        :indicators="simpleLayoutIndicators"
        :modelsLoaded="true"
    >
        <h1>Aide</h1>
        <div v-if="$store.getters.currentUser.is_client">
            <p>
                En tant que client, vous pouvez gérer les requêtes d'inspection sur la page <strong>Requêtes</strong>.
            </p>
        </div>
        <div v-if="!$store.getters.currentUser.is_client && !isBridgestoneUser">
            <p>
                En tant que partenaire, vous pouvez créer des requêtes d'inspection dans la page <strong>Véhicules</strong> et gérer vos requêtes d'inspection dans la page <strong>Requêtes</strong> pour chaque base qui vous est disponible.
            </p>
            <p>
                Vous devez choisir une base dans la page <strong>Bases</strong> ou bien en utilisant le composant de sélection en haut à droite de la page si vous avez plusieurs bases à gérer.
            </p>
        </div>
        <div v-if="isBridgestoneUser">
            <p>
                En tant qu'utilisateur Bridgestone, vous avez accès aux données de tous les clients et de tous les partenaires.
            </p>
            <p>
                Vous devez choisir une base dans la page <strong>Bases</strong> ou bien en utilisant le composant de sélection en haut à droite de la page si vous avez plusieurs bases à gérer.
            </p>
            <p>
                Pour chaque base, vous avez accès à tous les véhicules dans la page Véhicules et aux requêtes d'inspection dans la page <strong>Requêtes</strong>.
            </p>
        </div>
        <div>
            <h2>Requêtes</h2>
            <p>
                Dans la page <strong>Requêtes</strong>, vous pouvez gérer les requêtes d'inspection.
            </p>
            <el-row v-if="$store.getters.currentUser.is_client">
                <el-col :span="2"><el-button type="success" icon="el-icon-check"></el-button></el-col>
                <el-col :span="22">Vous pouvez confirmer une requête d'inpesction si vous approuvez la période de date proposée par le partenaire.</el-col>
            </el-row>
            <el-row v-if="!$store.getters.currentUser.is_client">
                <el-col :span="2"><el-button type="primary"><i class="ti-calendar"></i></el-button></el-col>
                <el-col :span="22">Vous pouvez reprogrammer une inspection si le client n'a pas encore répondu en cliquant sur le bouton de reprogrammation.</el-col>
            </el-row>
            <el-row v-if="$store.getters.currentUser.is_client">
                <el-col :span="2"><el-button type="primary"><i class="ti-calendar"></i></el-button></el-col>
                <el-col :span="22">Vous pouvez reprogrammer une inspection si la date proposée par le partenaire ne vous convient pas en cliquant sur le bouton de reprogrammation. Vous pouvez toujours reprogrammer une inspection même si vous l'avez déjà approuvée ou annulée.</el-col>
            </el-row>
            <el-row v-if="$store.getters.currentUser.is_client">
                <el-col :span="2"><el-button type="danger" icon="el-icon-delete"></el-button></el-col>
                <el-col :span="22">Vous pouvez annuler une requête d'inspection si le véhicule concerné ne fait plus partie de la base en cliquant sur le bouton d'annulation.</el-col>
            </el-row>
            <el-row>
                <el-col :span="2"><el-button type="primary"><i class="ti-comment-alt"></i></el-button></el-col>
                <el-col :span="22">Vous pouvez ajouter des commentaires en cliquant sur le bouton d'ajout de commentaire.</el-col>
            </el-row>
        </div>
        <div v-if="!$store.getters.currentUser.is_client">
            <h2>Véhicules</h2>
            <p>
                Sur la page <strong>Véhicules</strong>, vous pouvez créer des requêtes d'inspection en sélectionnant les véhicules dans le tableau.
            </p>
            <p>
                Chaque ligne du tableau a une couleur représentant à quel point il est urgent de réaliser une inspection :
                <ul class="list-status">
                    <li
                        v-for="statusName in colorsConfigStatuses">
                        <el-tag
                            :color="colorsConfig[statusName].color"
                        ></el-tag>

                        <span v-if="statusName === colorsConfigFirstStatus">
                            La date d'inspection a eu lieu il y a moins de {{colorsConfig[statusName].max}} jours
                        </span>
                        <span v-else-if="statusName === colorsConfigLastStatus">
                            La dernière inspection a eu lieu il y a plus de {{colorsConfig[statusName].threshold}} jours.
                        </span>
                        <span v-else>
                            La date d'inspection est ancienne de {{colorsConfig[statusName].threshold}} à {{colorsConfig[statusName].max}} jours.
                        </span>
                    </li>
                </ul>
            </p>
            <p>Une fois que vous avez sélectionné les véhicules, cliquer sur le bouton <el-button type="primary">Créer des requêtes d'inspection</el-button> pour sélectionner la période sur laquelle vous souhaitez inspecter les véhicules.</p>
        </div>
    </simple-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

    data () {
        return {

        };
    },

    computed: {
        ...mapGetters([
            'isBridgestoneUser',
            'simpleLayoutIndicators',
            'colorsConfig',
            'colorsConfigStatuses',
            'colorsConfigLastStatus',
            'colorsConfigFirstStatus',
        ]),
    }
};
</script>

<style lang="scss">
.help-page {

    .el-row {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }

    .list-status {
        list-style: none;

        li {
            display: flex;
            align-items: center;

            .el-tag {
                margin-right: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Help/Index.vue